import { css } from 'lit';

export default css`
  .nile-loader {
    border-radius: 50%;
    display: inline-block;
    border-top: 1px solid var(--nile-colors-blue-500);
    border-right: 1px solid var(--nile-colors-blue-500);
    box-shadow: 0 1px 1px -1px var(--nile-colors-blue-500);
    box-sizing: border-box;
    animation: rotation 0.5s linear infinite;
    padding: 30px;
  }

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
